document.addEventListener("DOMContentLoaded", function () {
    function initInfiniteSlider() {
        // Najdi oba slidy samostatně
        const topSlide = document.querySelector(".slide-top");
        const bottomSlide = document.querySelector(".slide-bottom");

        console.log("Top slide found:", topSlide);
        console.log("Bottom slide found:", bottomSlide);

        // Funkce pro inicializaci jednoho slideru
        function initSlide(slider, trackSelector) {
            if (!slider) {
                console.error("Slider not found");
                return;
            }

            const track = slider.querySelector(trackSelector);
            console.log("Track found:", track, "for selector:", trackSelector);

            if (!track) {
                console.error("Track not found for selector:", trackSelector);
                return;
            }

            const items = Array.from(track.children);
            console.log("Items found:", items.length);

            if (items.length === 0) return;

            // Získej šířku containeru
            const containerWidth = slider.offsetWidth;
            console.log("Container width:", containerWidth);

            // Spočítej šířku všech itemů + gapy
            const gap = 16; // 1.6rem = 16px
            let totalWidth = 0;
            items.forEach((item) => {
                totalWidth += item.offsetWidth + gap;
            });
            console.log("Total width of items:", totalWidth);

            // Vypočítej kolikrát musíme duplikovat
            const neededCopies = Math.max(3, Math.ceil((containerWidth * 2.5) / totalWidth));
            console.log("Needed copies:", neededCopies);

            // Vyklonuj items tolikrát, kolik je potřeba
            for (let i = 0; i < neededCopies; i++) {
                items.forEach((item) => {
                    const clone = item.cloneNode(true);
                    track.appendChild(clone);
                });
            }

            console.log("Total items after cloning:", track.children.length);
        }

        // Inicializuj oba slidy
        if (topSlide) {
            console.log("Initializing top slide...");
            initSlide(topSlide, ".slide-top__items");
        }

        if (bottomSlide) {
            console.log("Initializing bottom slide...");
            // Zkus najít track s oběma možnými selektory
            const bottomTrackExists = bottomSlide.querySelector(".slide-bottom__items");
            const bottomTrackAlt = bottomSlide.querySelector(".slide-top__items");

            if (bottomTrackExists) {
                initSlide(bottomSlide, ".slide-bottom__items");
            } else if (bottomTrackAlt) {
                console.warn("Using .slide-top__items for bottom slide as fallback");
                initSlide(bottomSlide, ".slide-top__items");
            } else {
                console.error("No track found in bottom slide!");
            }
        }
    }

    // Inicializuj slider
    initInfiniteSlider();

    // Reinicializuj při resize (debounced)
    let resizeTimer;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // Vyčisti a reinicializuj
            const topTrack = document.querySelector(".slide-top__items");
            const bottomTrack = document.querySelector(".slide-bottom__items");

            if (topTrack) {
                const originalItems = Array.from(topTrack.children).slice(0, 3);
                topTrack.innerHTML = "";
                originalItems.forEach((item) => topTrack.appendChild(item));
            }

            if (bottomTrack) {
                const originalItems = Array.from(bottomTrack.children).slice(0, 3);
                bottomTrack.innerHTML = "";
                originalItems.forEach((item) => bottomTrack.appendChild(item));
            }

            initInfiniteSlider();
        }, 250);
    });

    // SwiperJS pro testimonials
    function initTestimonialSwiper() {
        const testimonialSwiper = new Swiper(".testimonial__content", {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".buttons__next",
                prevEl: ".buttons__prev",
            },
            on: {
                slideChange() {
                    // Reset všechny progress bary
                    const allProgressBars = document.querySelectorAll(".testimonial__progress .progress-fill");
                    allProgressBars.forEach((bar) => {
                        bar.style.width = "0%";
                    });

                    // Spusť animaci pro aktivní slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
                init() {
                    // Spusť animaci pro první slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
            },
        });
    }

    // Inicializuj testimonial swiper
    if (document.querySelector(".testimonial__content")) {
        initTestimonialSwiper();
    }

    // Case Study Tabs funkcionalita s GSAP animacemi
    function initCaseStudyTabs() {
        const tabs = document.querySelectorAll(".case-study-tab");
        const contents = document.querySelectorAll(".case-study-content");

        if (tabs.length === 0 || contents.length === 0) return;

        // Nastav počáteční stav pro všechny obsahy (kromě prvního)
        contents.forEach((content, index) => {
            if (index === 0) {
                gsap.set(content, { display: "flex", opacity: 1, y: 0 });
            } else {
                gsap.set(content, { display: "none", opacity: 0, y: 30 });
            }
        });

        tabs.forEach((tab) => {
            tab.addEventListener("click", function () {
                const tabIndex = parseInt(this.getAttribute("data-tab"));
                const targetContent = document.querySelector(`[data-content="${tabIndex}"]`);
                const currentActiveContent = document.querySelector(".case-study-content.active");

                // Pokud je již tento tab aktivní, neděláme nic
                if (this.classList.contains("active")) return;

                // Animace pro tabs
                tabs.forEach((t) => t.classList.remove("active"));
                this.classList.add("active");

                // GSAP animace pro přepnutí obsahu
                const timeline = gsap.timeline();

                if (currentActiveContent && currentActiveContent !== targetContent) {
                    // Fade out současný obsah
                    timeline.to(currentActiveContent, {
                        opacity: 0,
                        y: -20,
                        duration: 0.3,
                        ease: "power2.out",
                        onComplete: () => {
                            gsap.set(currentActiveContent, { display: "none" });
                            currentActiveContent.classList.remove("active");
                        },
                    });
                }

                if (targetContent) {
                    // Fade in nový obsah
                    timeline.set(targetContent, { display: "flex" }).to(targetContent, {
                        opacity: 1,
                        y: 0,
                        duration: 0.4,
                        ease: "power2.out",
                        onStart: () => {
                            targetContent.classList.add("active");
                        },
                    });

                    // Animace pro jednotlivé elementy v obsahu
                    timeline
                        .from(
                            targetContent.querySelectorAll(".col-right__content-icons .icon"),
                            {
                                scale: 0.8,
                                opacity: 0,
                                duration: 0.3,
                                stagger: 0.1,
                                ease: "back.out(1.7)",
                            },
                            "-=0.2",
                        )
                        .from(
                            targetContent.querySelector(".col-right__content-headline"),
                            {
                                y: 20,
                                opacity: 0,
                                duration: 0.3,
                                ease: "power2.out",
                            },
                            "-=0.1",
                        )
                        .from(
                            targetContent.querySelectorAll(".desc-lists .item"),
                            {
                                x: -20,
                                opacity: 0,
                                duration: 0.3,
                                stagger: 0.1,
                                ease: "power2.out",
                            },
                            "-=0.1",
                        )
                        .from(
                            targetContent.querySelector(".col-right__content-text-button"),
                            {
                                y: 20,
                                opacity: 0,
                                duration: 0.3,
                                ease: "power2.out",
                            },
                            "-=0.2",
                        );
                }
            });
        });
    }

    // Inicializuj case study tabs
    if (document.querySelector("#case-study-tabs")) {
        initCaseStudyTabs();
    }

    // SwiperJS pro posts slider
    function initPostsSwiper() {
        const postsSwiper = new Swiper(".posts__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: true,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-posts__next",
                prevEl: ".buttons-posts__prev",
            },
        });
    }

    // Inicializuj posts swiper
    if (document.querySelector(".posts__slider-swiper")) {
        initPostsSwiper();
    }
});
